import React from 'react'
import PropTypes from 'prop-types'
import Card from '../../../../molecules/Card'
import ContentThingsTool from './Things'

const ContentTab = ({ accountId }) => {
  return (
    <Card variant='clear'>
      <ContentThingsTool accountId={accountId} />
    </Card>
  )
}

ContentTab.propTypes = {
  accountId: PropTypes.number
}

export default ContentTab
